var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "Field__Component" }, [
    _c(
      "div",
      [
        _vm._t("default", function () {
          return [
            _c(
              "div",
              {
                staticClass: "copy-link-button",
                attrs: { title: "העתק קישור" },
                on: { click: _vm.copyToClipboard },
              },
              [_c("b-icon", { attrs: { pack: "fa", icon: "copy" } })],
              1
            ),
          ]
        }),
      ],
      2
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }